import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

import { AuthService } from '../auth.service';
import { NavigationService } from '../../services/navigation.service';
import { SessionExpiredModalComponent } from '../../components/session-expired-modal/session-expired-modal.component';

@Injectable({
  providedIn: 'root'
})
export class SessionExpiredGuard implements CanActivate, CanActivateChild {

  constructor(private authService: AuthService, private modalService: NgbModal, private navigationService: NavigationService) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.isAuthorized();
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean>|Promise<boolean>|boolean {
    return this.isAuthorized();
  }

  private isAuthorized() {
    if (!this.authService.isLoggedIn && !this.authService.authenticating && !this.authService.error) {
      this.navigationService.reset();
      this.modalService.open(SessionExpiredModalComponent, this.authService.modalConfig as NgbModalOptions);
      return false;
    }
    return true;
  }
}
